var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.39 26.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f57224;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.47,21.92h.14l3.73-.34c.52-.05,1.01-.28,1.38-.65l14.09-14.09c.66-.66,1.03-1.54,1.03-2.47s-.37-1.81-1.03-2.47l-.9-.9c-1.32-1.32-3.63-1.32-4.96,0l-1.8,1.8h0L3.87,15.07c-.37.37-.6.85-.64,1.38l-.34,3.73c-.04.47.13.93.46,1.27.31.31.7.47,1.12.47ZM20.43,1.87c.41,0,.82.15,1.12.47l.9.9c.31.31.47.7.47,1.12s-.17.83-.47,1.12l-1.12,1.12-3.15-3.15,1.12-1.12c.31-.31.71-.47,1.12-.47ZM5.13,16.62c0-.08.04-.14.09-.19l11.6-11.62,3.15,3.15-11.6,11.6s-.13.09-.19.09l-3.35.31.31-3.35h0ZM27.39,25.99c0,.52-.43.96-.96.96H.96c-.52,0-.96-.43-.96-.96s.43-.96.96-.96h25.48c.52,0,.96.43.96.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e202c4886734fd7b5d204c64618e36d5.svg";
export { ForwardRef as ReactComponent };